import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpStaffProvider extends HttpService{

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * スタッフリスト取得
   */
  getList(conditions): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/staffs/getList");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * スタッフリスト取得
   */
  getOne(conditions): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/staffs/getOne");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 記録登録処理
   */
  iconSave(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/staffs/iconSave");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * ユーザ登録処理
   */
  register(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/users/register");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * パスワードリセット
   */
  passwordReset(userId:string): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/users/passwordReset");
    var options = super.buildParam(userParam);

    return super.post(options, {userId:userId});
  }

  /**
   * 同意書文言登録
   */
  saveSignMessage(data: object): Observable<any> {
      //パラメータ設定
      let userParam = new URLSearchParams();
      userParam.set("api", "/staffs/saveSignMessage");
      var options = super.buildParam(userParam);
      return super.post(options, data);
  }

  /**
   * 同意書文言登録
   */
  getSignMessage(): Observable<any> {
    let userParam = new URLSearchParams();
    // userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/staffs/getSignMessage");
    var options = super.buildParam(userParam);

    return super.get(options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-staff.ts